<template>
	<div class="wrap">
        <div class="title">您的当前位置：首页&lt;热门推荐 </div>
      <!--内容-->
      		<div class="contentF">
      			<div class="boxF" v-for="(val,index) in arrOne" @click="goDetails(val)">
      				<div class="imgF"><img :src=val.cover :alt="val.totalTitle"></div>
      				<div class="titleF">{{val.totalTitle}}</div>
      				<div class="timeF">{{ val.creaTime.time | dateFormat}} <span class="viewF">浏览量:{{val.popularity}}</span></div>
      			</div>
      
      		</div>
      	<pagebreak :totalPage="totalPage" @changePage="changePage"></pagebreak>
      	</div>
      </template>
      <script type="text/javascript">
      	export default {
      		name: 'zxkc',
      		data() {
      			return {
      				arrOne: [],
      				totalPage: 1,
      				page:1,
      			}
      		},
      		methods: {
      			//课程详情
      			goDetails(val){
      				this.$router.push({name:'classDetails',query:{id:val.id,title:val.totalTitle}})
      			},
      			//切换页码
      			changePage(index) {
      				this.page=index;
      				this.changeHot();
      			},
      			
      			
      			
      			changeHot() {
      				//在线课程
      				this.$ajax({
      					method: "post",
      					url: "homePage/getCoursesSeries",
      					data:{
								isHot: 1,
								curren:this.page,
							},
      					success: res => {
      						this.totalPage = Math.ceil(
      							res.message.total / res.message.size
      						);
      						this.arrOne = res.message.records;
      					},
      					error: res => {
      						console.log(res);
      					}
      				});
      			}
      
      
      		},
      		created() {
      			
      			this.changeHot();
      		}
      	}
      </script>
      <style scoped="scoped">
      	.wrap {
      		width: 1000px;
      		overflow: hidden;
      		margin: 0 auto;
      	}
        .title {
          color: gray;
      }
      
      	.contentF {
      		width: 1000px;
      		display: flex;
      		/* justify-content: space-between; */
      		flex-direction: row;
      		flex-wrap: wrap;
      		min-height: 500px;
      		align-content: flex-start;
      		align-items: flex-start;
      	}
      
      	.headerSpanF {
      		margin-right: 10px;
      		cursor: pointer;
      		color: black;
      	}
      
      	.chooseColor {
      		margin-right: 10px;
      		cursor: pointer;
      		color: #6AC0E8;
      	}
      
      	.boxF {
      		width: 242.5px;
      		display: inline-block;
      		margin-top: 10px;
      		margin-right: 10px;
      	}
      
      	.boxF:nth-child(4n) {
      		margin-right: 0;
      	}
      
      	.imgF {
      		width: 100%;
      		height: 164.9px;
					border: 1px solid #ddd;
					box-sizing: border-box;
      	}
      
      	.imgF img {
      		width: 100%;
      		height: 100%;
			
      	}
      	.viewF {
      		float: right;
      	}
      
      	.twoHeader {
      		margin-top: 10px;
      	}
      
      	.twoSpanF {
      		margin-right: 10px;
      		font-size: 14px;
      		color: gray;
      		cursor: pointer;
      	}
      
      	.changeColorTwo {
      		margin-right: 10px;
      		font-size: 14px;
      		color: #6AC0E8;
      		cursor: pointer;
      	}
      
      	.timeF {
      		height: 20px;
      		line-height: 20px;
      		font-size: 14px;
      		color: gray;
      	}
      
      	.titleF {
      		overflow: hidden;
      		text-overflow: ellipsis;
      		white-space: nowrap;
      	}
      </style>
      



// WEBPACK FOOTER //
// src/components/shouye/hot.vue